export default {
    devicemodel_tab_name: "Name",
    devicemodel_tab_product: "Product",
    devicemodel_tab_inputs: "Inputs",
    devicemodel_tab_outputs: "Outputs",
    devicemodel_tab_status: "Status",
    devicemodel_tab_add_new: "Add New",
    devicemodel_tab_unit_type: "Unit type",
    devicemodel_tab_support_geofences: "Support Geofences",
    devicemodel_tab_geofence_type: "Geofence Type",
    devicemodel_tab_geofence_polygon: "Polygon",
    devicemodel_tab_geofence_regular_shape: "Regular Shape",
    devicemodel_tab_geofence_both: "Both",
    devicemodel_tab_bulk_assign_alert_types: "Bulk Assign Alert Types",
}